import { Component, OnInit } from '@angular/core';
import {
  MenuService,
  LogoService,
  FooterService
} from './ngx-admin-lte';
import { environment } from '../environments/environment';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent implements OnInit {
  // define your footer links
  private footer = {
      left_part: `<strong>
        Copyright &copy; 2019
        <a href="http://www.weberantoine.fr" >WEBER Antoine</a>.
    	</strong>
      Gestion de salon de coiffure`,
      right_part: environment.name,
    };
  // define here your own links menu structure
  private mylinks: any =[
    {title:"Caisse",icon:"shopping-cart",link:["/"]},
    {title:"Clients",icon:"users",link:["/client"]},
    {title:"Produits",icon:"eyedropper",link:["/produit"]},
    {title:"Prestations",icon:"hand-scissors-o",link:["/prestation"]},
    {title:"Categories",icon:"hand-scissors-o",link:["/categorie"]},
    {title:"Factures",icon:"money",link:["/facture"]},
    {title:"Coiffeuse",icon:"users",link:["/user"]},
  ];

  // define here your logo
  private logo = {
    html_mini: "<b>"+environment.partname[0][0]+"</b>"+environment.partname[1][0],
    html_lg: "<b>"+environment.partname[0]+"</b>"+environment.partname[1],
  };

  constructor(
    private footerServ: FooterService,
    private menuServ: MenuService,
    private logoServ: LogoService,
  ) {

  }

  public ngOnInit() {
    // define menu
    this.menuServ.setCurrent(this.mylinks);
    this.footerServ.setCurrent(this.footer);
    this.logoServ.setCurrent(this.logo);
  }

}
